export default "__VITE_ASSET__hSzvTh6b__"